import { useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';

// time a card must stay in view to count as viewed. Avoids tracking fast scroll down.
const DWELL_TIME_MS = 200;

/**
 * Fires a callback once when an element has been fully visible in the viewport
 * for a short dwell time. Returns a ref to attach to the tracked element.
 */
export const useTileInView = (onInView: () => void) => {
  const hasFiredRef = useRef(false);
  // keep latest callback without restarting the dwell timer
  const onInViewRef = useRef(onInView);
  onInViewRef.current = onInView;

  const [inViewRef, inView] = useInView({
    // 0.8: cross-browser including Safari mobile; threshold: 1.0 is unreliable on Safari
    threshold: 0.8,
  });

  useEffect(() => {
    if (!inView || hasFiredRef.current) return;

    const timer = setTimeout(() => {
      hasFiredRef.current = true;
      onInViewRef.current();
    }, DWELL_TIME_MS);

    return () => {
      clearTimeout(timer);
    };
  }, [inView]);

  return inViewRef;
};
